module.exports = __webpack_public_path__ + "media/background.49ff4761.mp4";